<template>
  <div class="filterbar-wrapper" :class="{ open: filterbarOpen }">
    <div class="filterbar-overlay" @click="closeFilterbar"></div>
    <div class="filterbar-container">
      <i class="fa fa-times filterbar-close" @click="closeFilterbar"></i>
      <h4 class="filterbar-title">
        <img :src="require('@/assets/images/icon-filter.svg')" alt="" />
        Filter by:
      </h4>
      <slot name="filterbar-content"></slot>
      <div class="w-100 text-right my-4">
        <span @click="resetFilters" class="filterbar-reset">
          Reset Filters
        </span>
      </div>
      <div class="w-100 text-center">
        <button
          class="btn btn-primary btn-sm filterbar-button"
          @click="applyFilters"
        >
          Apply Filters
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'app-filterbar',
  computed: {
    ...mapGetters(['filterbarOpen'])
  },
  methods: {
    closeFilterbar() {
      this.$store.dispatch('toggleFilterbar', false)
    },
    applyFilters() {
      this.$emit('apply-filters')
    },
    resetFilters() {
      this.$emit('reset-filters')
    }
  },
  watch: {
    filterbarOpen(val) {
      document.body.style.overflow = val ? 'hidden' : ''
    }
  }
}
</script>

<style lang="scss">
.filterbar-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 9998;
  visibility: hidden;
  transform: translateX(-300px);
  transition: all 0.2s ease-in-out;
  &.open {
    visibility: visible;
    transform: translateX(0);
  }
  .filterbar-container {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 300px;
    background-color: #808080;
    box-shadow: $blueish-box-shadow;
    padding: 80px 30px;
    color: $white;
    overflow-y: auto;
    .filterbar-close {
      position: absolute;
      right: 20px;
      top: 90px;
      font-size: 1.2rem;
      transform: scale(1);
      transition: all 0.2s ease-in;
      &:hover {
        transform: scale(1.15);
        cursor: pointer;
      }
    }
    .filterbar-title {
      color: $white;
      display: flex;
      align-items: flex-end;
      margin-bottom: 50px;
      position: relative;
      &:after {
        content: '';
        display: block;
        width: 55%;
        border-bottom: 2px solid #ffffff;
        margin: 10px 0;
        position: absolute;
        bottom: -25px;
      }
      img {
        width: 24px;
        height: 27px;
        margin-right: 10px;
      }
    }
    .filterbar-input {
      display: flex;
      flex-direction: column;
      margin-bottom: 25px;
      label {
        cursor: pointer;
        display: flex;
        align-items: center;
        font-weight: 200;
        font-size: 20px;
        margin-bottom: 0;

        input {
          margin-right: 10px;
        }
      }
      .filter-selector {
        font-weight: 400;
        font-size: 20px;
        margin-bottom: 0;
        line-height: 1.3;
      }
      .sub-filter {
        padding-left: 20px;
        font-size: 18px;
        line-height: 1.2;
      }
      .form-group {
        margin: 0;
        background-color: #fff;
        border-radius: 0.2rem;
        min-height: 2rem !important;
        &.with-icon-right {
          .icon-right {
            right: 10px;
          }
        }
        i.bar {
          display: none;
        }
        input.has-value {
          color: $darkblue;
        }
      }
    }
    // .filterbar-button {
    //   border: 2px solid $white;
    // }
    .filterbar-reset {
      &:hover {
        cursor: pointer;
      }
    }
  }
  .filterbar-overlay {
    position: fixed;
    top: 72px;
    right: 0;
    bottom: 0;
    width: calc(100% - 300px);
  }
  .vuestic-date-picker {
    border: none;
    border-radius: 0.2rem;
    margin: 2px 0;
    padding: 5px;
    color: $darkblue;
    &:focus {
      outline: none;
    }
  }
}
</style>
